<div class="container" *ngIf="aircraft">
     <label class="title">{{aircraftMfr(aircraft)}} {{aircraft.type?.long || 'unknown'}}</label>

     <div class="sub-title">AA Aircraft Details</div>
     <div class="row">
          <div class="col left">
               <div>Fleet</div>
               <div>Sub Fleet</div>
               <div>FOS ID</div>
               <div>Nose Number</div>
               <div>Equipment Number</div>
          </div>
          <div class="col right">
               <div>{{aircraft.type?.fleet}}</div>
               <div>{{aircraft.type?.subFleet}}</div>
               <div>{{aircraft.type?.fos}}</div>
               <div>{{stripNchar(aircraft)}}</div>
               <div>{{aircraft.type?.equipmentNumber}}</div>
          </div>

     </div>
     <div class="sub-title">FAA Aircraft Details</div>
     <div class="row">
          <div class="col left">
               <div>Registration</div>
               <div>Type</div>
               <div>Serial Number</div>
          </div>
          <div class="col right">
               <div>{{aircraft.faa}}</div>
               <div>{{aircraft.type?.faaType}}</div>
               <div>#{{aircraft.mfrsn}}</div>
     </div>
</div>